<template>
    <flex-container
        justify-content="space-between"
        direction="column"
        height="full"
        class="assistent-menu"
    >
        <flex-container
            size="full"
            direction="column"
            justify-content="space-between"
            class="menu"
        >
            <flex-container
                size="full"
                direction="column"
                align-content="stretch"
                class="assistent-menu__items"
                :gap="Size.sm"
                :padding="Size.md"
            >
                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-personality' }"
                    title="Persoonlijkheid"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-advanced' }"
                    title="Geavanceerd"
                    :disabled="dropdownVisible"
                />

                <flex-container
                    v-show="dropdownVisible"
                    direction="column"
                    justify-content="space-between"
                    :gap="Size.sm"
                    no-wrap
                    size="auto"
                    class="assistent-menu__advanced"
                >
                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-functionality' }"
                        title="Functionaliteiten"
                    />

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-options' }"
                        title="Snelle opties"
                    />

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-knowledge' }"
                        title="Kennis"
                    />

                    <!--                    <assistent-menu-item-->
                    <!--                        :to="{ name: 'assistent-chat-edit-flows' }"-->
                    <!--                        title="Flows"-->
                    <!--                    />-->

                    <!--                    <assistent-menu-item-->
                    <!--                        :to="{ name: 'assistent-chat-edit-realworks' }"-->
                    <!--                        title="Realworks"-->
                    <!--                    />-->

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-display' }"
                        title="Weergave"
                    />

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-chat-connect' }"
                        title="ChatConnect"
                    />

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-instruction' }"
                        title="Instructie"
                        chip-title="Expert"
                        :chip-color="'primary'"
                    />

                    <assistent-menu-item
                        :to="{ name: 'assistent-chat-edit-embed-code' }"
                        title="Embed Code"
                    />
                </flex-container>
            </flex-container>
            <slot />
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { FlexContainer, Size } from '@keyvue/one-ui';
    import AssistentMenuItem from '@/ai/assistent/components/AssistentMenuItem.vue';
    import { useRouter } from 'vue-router';

    const router = useRouter();
    const dropdownVisible = computed(() => {
        return [
            'assistent-chat-edit-functionality',
            'assistent-chat-edit-knowledge',
            'assistent-chat-edit-display',
            'assistent-chat-edit-instruction',
            'assistent-chat-edit-options',
            'assistent-chat-edit-embed-code',
            'assistent-chat-edit-chat-connect',
            'assistent-chat-edit-chat-connect-goal',
            'assistent-chat-edit-chat-connect-system-goals',
        ].includes(router?.currentRoute?.value?.name?.toString() ?? '');
    });
</script>

<style scoped lang="scss">
.assistent-menu {
    &__items {
        padding: 0 16px;
        align-content: stretch;

        /** tijdelijk: bij fase twee er uit **/
        .disabled {
            pointer-events: none;
            color: color(gray-300);
            display: none;
        }
    }

    &__advanced {
        padding-left: size(sm);
    }
}
</style>
